import { render, staticRenderFns } from "./GoodsCombinationDetails.vue?vue&type=template&id=ea506388&scoped=true"
import script from "./GoodsCombinationDetails.vue?vue&type=script&lang=js"
export * from "./GoodsCombinationDetails.vue?vue&type=script&lang=js"
import style0 from "./GoodsCombinationDetails.vue?vue&type=style&index=0&id=ea506388&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea506388",
  null
  
)

export default component.exports